// docs: https://github.com/altostra/type-validations#readme
import type { TypeValidation } from "@altostra/type-validations";
import { arrayOf, enumOf, is, objectOf, taggedUnionOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";
import type {
  ConfigurationData,
  DomainStatus,
} from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData/types";

export const isDomainStatus = enumOf<DomainStatus>("PENDING", "SUCCESS", "FAILED");

export const isSendingDomain = objectOf({
  id: string,
  domain: string,
  status: isDomainStatus,
  appGroupIds: arrayOf(string),
  autoAddedToAppGroups: boolean,
});

export const isTrackingDomain = objectOf({
  parentId: string,
  domain: string,
  status: isDomainStatus,
});

export const isIpPool = objectOf({
  name: string,
  ipAddresses: arrayOf(string),
  sendingDomains: arrayOf(isSendingDomain),
  trackingDomains: arrayOf(isTrackingDomain),
});

export const isDelegatedDomain = objectOf({
  id: string,
  domain: string,
});

export const isConfigurationData = taggedUnionOf("status", {
  ADD_IP_POOL: objectOf({
    status: is("ADD_IP_POOL"),
  }) as TypeValidation<ConfigurationData>,
  ADD_IP_ADDRESSES: objectOf({
    status: is("ADD_IP_ADDRESSES"),
  }),
  ADD_DELEGATED_DOMAIN: objectOf({
    status: is("ADD_DELEGATED_DOMAIN"),
  }),
  COMPLETED: objectOf({
    status: is("COMPLETED"),
    ipPools: arrayOf(isIpPool),
    delegatedDomains: arrayOf(isDelegatedDomain),
  }),
});

export const isGetConfigurationDataResult = objectOf({
  data: isConfigurationData,
});
